module.exports = __webpack_public_path__ + "static/media/nu5.0da9dbc0.webp";